
import { common as jaCommon } from './ja/common';
import { common as enCommon } from './en/common';

const resources = {
  ja: {
    common: jaCommon
  },
  en: {
    common: enCommon
  }
};

export default resources;
